import React, { useState, useEffect, useMemo } from 'react';
import { Form, Container, Row, Col, Button } from 'react-bootstrap';
import { toast, ToastContainer } from "react-toastify";

import { useUser } from "../../UserContext"; // importa il contesto utente

import "react-toastify/dist/ReactToastify.css";
import "../../../css/InsertData.css";


function InsertData({ columns, tableName, onInsert }) {

  const { role } = useUser(); // 🔹 Ottieni il ruolo dell’utente loggato
  const [formDataInsert, setFormDataInsert] = useState({});

  const API_URL = process.env.REACT_APP_API_URL;

  // 🔹 Determina le colonne ammesse in base al ruolo
  const visibleColumns = useMemo(() => {

    if (role === "admin") {
      return columns;
    }

    if (role === "elettrico") {
      const blocked = [
        "Temperature [°C]",
        "AirPressure [bar]",
        "GasPressure_O2 [bar]",
        "GasPressure_N2 [bar]",
        "GasPressure_Air [bar]",
      ];
      return columns.filter(col => !blocked.includes(col));
    }

    if (role === "meccanico") {
      const allowed = [
        "Model",
        "Version",
        "Diagram",
        "LaserType",
        "Temperature [°C]",
        "AirPressure [bar]",
        "GasPressure_O2 [bar]",
        "GasPressure_N2 [bar]",
        "GasPressure_Air [bar]",
      ];
      return columns.filter(col => allowed.includes(col));
    }

    // Nessun login → non mostra nulla
    return [];
  }, [columns, role]);

  // Inizializza formData in base alle colonne visibili
  useEffect(() => {
    setFormDataInsert(
      visibleColumns.reduce((acc, col) => ({ ...acc, [col]: '' }), {})
    );
  }, [visibleColumns]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataInsert(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Controlla campi obbligatori
    if (!formDataInsert["Version"]?.trim() || !formDataInsert["LaserType"]?.trim()) {
      toast.warning("Version e LaserType sono obbligatori.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/insertDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          tableName,
          formDataInsert: JSON.stringify(formDataInsert),
        }),
      });

      if (!res.ok) throw new Error("Errore nell'inserimento del dato");

      await res.json();
      toast.success("Dato inserito con successo");

      // Reset form
      setFormDataInsert(
        visibleColumns.reduce((acc, col) => ({ ...acc, [col]: '' }), {})
      );

      if (onInsert) onInsert();

    } catch (err) {
      console.error(err);
      toast.error(err.message || "Errore imprevisto");
    }
  };

  const isButtonEnabled =
    formDataInsert["Version"]?.trim() && formDataInsert["LaserType"]?.trim();

  // Se utente non loggato, mostra solo un messaggio
  if (!role) {
    return (
      <Container className="mt-5 text-center">
        <h5>Effettua il login per inserire nuovi dati.</h5>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <ToastContainer position="top-right" autoClose={3000} />

      <Form onSubmit={handleSubmit} className="mb-4 insert-form">
        <Row>
          {visibleColumns.map((col) => {
            if (col === "ID" || col === "ID_version") return null;
            return (
              <Col key={col} md={3} className="mb-3">
                <Form.Group controlId={`form-${col}`}>
                  <Form.Label>{col}</Form.Label>
                  <Form.Control
                    type="text"
                    name={col}
                    value={formDataInsert[col]}
                    onChange={handleChange}
                    placeholder={`Inserisci ${col}`}
                  />
                </Form.Group>
              </Col>
            );
          })}
        </Row>

        <Row className="mt-4 mb-4">
          <Col className="text-center">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="insert-button"
              disabled={!isButtonEnabled}
            >
              INSERISCI RIGA
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default InsertData;
